import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, TextField, CircularProgress, duration, IconButton } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import toJs from "../../../../hoc/toJS";
import select from "../../../../utils/select";
import KPMonthYearPicker from "../../../../components/KPMonthYearPicker/KPMonthYearPicker";

import { notification } from "../../../../reducer/home/action";
import { getDOI } from "../../../../reducer/scientificResearch/action";
import {
  getSearchFilteredJournal,
  getJournalByIdOnScientificResearch,
  getSearchFilteredJournalAfterDOI,
} from "../../../../reducer/journal/action";
import { Link, Tab } from "@material-ui/icons";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

function JournalInternational(props) {
  const { values, setValues, handleChangeForm } = props;

  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 300);
  // console.log("debouncedSearchText", debouncedSearchText, props.listSearch);

  useEffect(() => {
    if (values?.publication?.title) setSearchText(values?.publication?.title);
  }, [props.updating, values?.publication?.title]);

  useEffect(() => {
    if (
      debouncedSearchText !== 0 &&
      debouncedSearchText !== props.journalSearchFilterText &&
      !props.isFetchingJournalSearchFilter
    )
      props.getSearchFilteredJournal(1, 20, { title: debouncedSearchText });
  }, [debouncedSearchText]);

  useEffect(() => {
    if (!(Object.keys(props.DOI).length === 0 && props.DOI.constructor === Object)) {
      if (!props.DOI?.issued) {
        props.notification({ type: "warning", message: "Link DOI không hợp lệ, vui lòng kiểm tra lại" });
        return;
      }
      const datePart = props.DOI.issued["date-parts"][0];
      // console.log("doi", props.DOI, props.isNeedReload);
      // console.log(
      //   "datePart",
      //   datePart,
      //   props.DOI?.["container-title"].replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""),
      //   props.DOI?.ISSN?.[0],
      //   (props.DOI?.ISSN?.[0] || props.DOI?.ISBN?.[0])?.replace("-", "")
      // );

      props.getSearchFilteredJournalAfterDOI(
        1,
        100,
        {
          title: props.DOI?.["container-title"].replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""),
          issn: (props.DOI?.ISSN?.[0] || props.DOI?.ISBN?.[0])?.replace("-", ""),
          year: datePart.length >= 1 ? datePart[0] : null,
          similarity: 0.8,
        },
        props.DOI,
      );
    }
  }, [props.isNeedReload]);

  useEffect(() => {
    setValues({
      ...values,
      sjrBestQuartile: null,
      rank: null,
      topRank: null,
      coreCollection: null,
      impactFactor: null,
      impactFactorFiveYear: null,
      submissionToAcceptance: null,
    });
  }, [values?.journalId]);

  useEffect(() => {
    if (
      // props.listSearchAfterDOI && props.listSearchAfterDOI.length !== 0 &&
      props.infoFromDoiLink &&
      props.infoFromDoiLink.length !== 0
    ) {
      if (props.listSearchAfterDOI.length == 0) {
        props.notification({
          type: "warning",
          message: "Không tìm thấy tạp chí trong cơ sở dữ liệu. Hệ thống đã tự điền tên tạp chí vào phần tạp chí khác.",
          duration: 5000,
        });
      }
      let tempListAuthor = "";
      (props.infoFromDoiLink?.author || [])?.forEach((author) => {
        const tempAuthor = `${author.given} ${author.family}`;
        if (tempListAuthor === "") tempListAuthor += tempAuthor;
        else tempListAuthor += `, ${tempAuthor}`;
      });

      // Lây ngày nộp đơn từ issued
      const issuedDay = new Date(2021, 0, 1);
      const createdDay = new Date(2021, 0, 1);
      const datePartIssued = props.infoFromDoiLink.issued["date-parts"][0];
      const datePartCreated = props.infoFromDoiLink.created["date-parts"][0];

      if (datePartIssued.length >= 1) issuedDay.setFullYear(datePartIssued[0]);
      if (datePartCreated.length >= 1) createdDay.setFullYear(datePartCreated[0]);

      // console.log(props.infoFromDoiLink?.author);
      setValues({
        ...values,
        doi: `https://doi.org/${props.infoFromDoiLink.DOI}`,
        title: props.infoFromDoiLink.title,
        numberMainAuthor: props.infoFromDoiLink?.author?.filter((e) => e.sequence === "first")?.length,
        issn: props.infoFromDoiLink?.ISSN?.[0] || props.infoFromDoiLink?.ISBN?.[0],
        issue: props.infoFromDoiLink.issue === undefined ? "" : props.infoFromDoiLink.issue,
        listAuthor: tempListAuthor,
        page: props.infoFromDoiLink.page === undefined ? "" : props.infoFromDoiLink.page,
        publisher: props.infoFromDoiLink.publisher === undefined ? "" : props.infoFromDoiLink.publisher,
        volume: props.infoFromDoiLink.volume === undefined ? "" : props.infoFromDoiLink.volume,
        numOfMember: props.infoFromDoiLink.author?.length,
        journalId: props.listSearchAfterDOI[0]?.id ?? null,
        otherTitle: props.listSearchAfterDOI?.length === 0 ? props.infoFromDoiLink["container-title"] : "",
        submissionDay: datePartIssued[0] > new Date().getFullYear() ? new Date(createdDay) : new Date(issuedDay),
        acceptedDay: new Date(issuedDay),
        year: parseInt(props.infoFromDoiLink.issued["date-parts"]),
      });
    }
  }, [props.isFetchingAfterDOI]);

  useEffect(() => {
    const { journalDetail } = props;
    if (values?.journalId !== 0)
      setValues({
        ...values,
        sjrBestQuartile: journalDetail?.sjrBestQuartile,
        rank: journalDetail?.rank,
        topRank: journalDetail?.topRank,
        coreCollection: journalDetail?.coreCollection,
        impactFactor: journalDetail?.impactFactor,
        impactFactorFiveYear: journalDetail?.impactFactorFiveYear,
        submissionToAcceptance: journalDetail?.submissionToAcceptance,
      });
  }, [props.isFetchingJournalDetail]);

  const handleGetDataFromDOI = () => {
    const type1 = "https://doi.org/";
    const type2 = "doi.org/";
    if (values?.doi?.substr(0, type1.length) === type1) {
      props.getDOI(values?.doi);
    } else if (values?.doi?.substr(0, type2.length) === type2) {
      props.getDOI(`https://${values?.doi}`);
    } else {
      props.getDOI(`https://doi.org/${values?.doi}`);
    }
  };

  const handleGetRankFromJournal = () => {
    if (values?.journalId === 0) {
      props.notification({ type: "error", message: "Vui lòng nhập tạp chí" });
    } else {
      props.getJournalByIdOnScientificResearch(values?.journalId);
    }
  };

  // console.log("JournalInternational render", values, props.updating);
  return (
    <>
      <Grid item xs={8}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Link DOI"
          variant="outlined"
          value={values?.doi || ""}
          onChange={(event) => handleChangeForm("doi", event.target.value)}
          helperText={
            !values?.doi ? (
              <div style={{ color: "red" }}>Vui lòng upload file minh chứng nếu công bố không có link DOI</div>
            ) : null
          }
        />
      </Grid>
      <Grid item xs={1}>
        {/* Mở tab đến link doi nếu có link */}
        {/* <Button
          fullWidth
          variant="contained"
          color="default"
          onClick={() => {
            if (values?.doi) window.open(values?.doi, "_blank");
          }}
          disabled={props.disabled || !values?.doi}
        >
          Mở DOI
        </Button> */}
        {/* Thay bằng icon cho tôi */}
        <Button
          fullWidth
          variant="contained"
          disabled={props.disabled || !values?.doi}
          startIcon={<Link />}
          onClick={() => {
            if (values?.doi) window.open(values?.doi, "_blank");
          }}
          style={{ float: "right" }}
        >
          Mở
        </Button>
      </Grid>
      <Grid item xs={3}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => handleGetDataFromDOI()}
          disabled={
            props.disabled ||
            props.isFetchingDOI ||
            props.isFetchingAfterDOI ||
            values?.locked === "kpi" ||
            values?.locked === "reward" ||
            values?.lockedForTimeResearch
          }
        >
          {props.isFetchingDOI || props.isFetchingAfterDOI ? <CircularProgress size={24} /> : "Nhập từ link DOI"}
        </Button>
      </Grid>
      <Grid item xs={10}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Tên công bố"
          variant="outlined"
          value={values?.title || ""}
          onChange={(event) => handleChangeForm("title", event.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Mã CTKH"
          variant="outlined"
          value={values?.hemisCode || ""}
          onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Nhà xuất bản"
          variant="outlined"
          value={values?.publisher || ""}
          onChange={(event) => handleChangeForm("publisher", event.target.value)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="ISSN/ISBN"
          variant="outlined"
          value={values?.issn || ""}
          onChange={(event) => handleChangeForm("issn", event.target.value)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Số lượng tác giả"
          variant="outlined"
          type="numOfMember"
          value={values?.numOfMember || ""}
          onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value), 10)}
          error={!(values?.numOfMember > 0)}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Số lượng tác giả chính"
          variant="outlined"
          type="number"
          value={values?.numberMainAuthor || ""}
          onChange={(event) => handleChangeForm("numberMainAuthor", parseInt(event.target.value, 10))}
          error={!(values?.numberMainAuthor > 0)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Tác giả"
          variant="outlined"
          value={values?.listAuthor || ""}
          multiline
          rows={4}
          onChange={(event) => handleChangeForm("listAuthor", event.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Issue"
          variant="outlined"
          value={values?.issue || ""}
          onChange={(event) => handleChangeForm("issue", event.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Volume"
          variant="outlined"
          value={values?.volume || ""}
          onChange={(event) => handleChangeForm("volume", event.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Page"
          variant="outlined"
          value={values?.page || ""}
          onChange={(event) => handleChangeForm("page", event.target.value)}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          select
          size="small"
          disabled={props.disabled || values?.locked === "kpi" || values?.locked === "reward"}
          label="Mục đích"
          variant="outlined"
          value={values?.purposeId ?? "none"}
          SelectProps={{ native: true }}
          onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value, 10))}
        >
          {props.purposes.map((e) => (
            <option key={e.id} value={e.id}>
              {e.description}
            </option>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={6}>
        <KPMonthYearPicker
          fullWidth
          disabled={props.disabled}
          label="Tháng/Năm nộp"
          required
          value={values?.submissionDay || `01/01/${new Date().getFullYear()}`}
          setValue={(newValue) => {
            // newValue có dạng "01/mm/yyyy"
            const parts = newValue.split("/");
            if (parts.length === 3) {
              const day = parseInt(parts[0], 10);
              const month = parseInt(parts[1], 10);
              const year = parseInt(parts[2], 10);

              // Lưu submissionMonth
              handleChangeForm("submissionMonth", month);

              // Lưu submissionDay là Date object với ngày 1 của tháng đó, giờ 12:00 để tránh lệch múi giờ
              const date = new Date(year, month - 1, day, 12, 0, 0);
              handleChangeForm("submissionDay", date);
            }
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <KPMonthYearPicker
          fullWidth
          disabled={props.disabled}
          label="Tháng/Năm chấp nhận"
          required
          value={values?.acceptedDay || `01/01/${new Date().getFullYear()}`}
          setValue={(newValue) => {
            // newValue có dạng "01/mm/yyyy"
            const parts = newValue.split("/");
            if (parts.length === 3) {
              const day = parseInt(parts[0], 10);
              const month = parseInt(parts[1], 10);
              const year = parseInt(parts[2], 10);

              // Lưu acceptedMonth
              const date = new Date(year, month - 1, day, 12, 0, 0);
              handleChangeForm("acceptedMonth", month);

              // Lưu acceptedDay là Date object với ngày 1 của tháng đó, giờ 12:00 để tránh lệch múi giờ
              handleChangeForm("acceptedDay", date);
            }
          }}
        />
      </Grid>
      {/* <Grid item xs={4}>
        <TextField
          fullWidth
          disabled={props.disabled}
          size="small"
          type="number"
          label="Điểm GS-PGS"
          variant="outlined"
          value={values?.score?.toString() || ""}
          onChange={(event) => handleChangeForm("score", parseFloat(event.target.value))}
        />
      </Grid> */}
      {props.isFetchingJournal ? (
        <CircularProgress size={24} />
      ) : (
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            size="small"
            disabled={props.disabled}
            // disableClearable
            options={props.listSearch || []}
            getOptionLabel={(option) => (option ? `${option?.title} (${option?.year})` : "")}
            // onInputChange={(e) => e && setSearchText(e?.target?.value)}
            inputValue={searchText}
            onInputChange={(event, newValue) => setSearchText(newValue)}
            onChange={(event, val) => {
              if (val !== null) handleChangeForm("journalId", val.id);
              else handleChangeForm("journalId", 0);
            }}
            value={props.listSearch.find((e) => e.id === values?.journalId) || null}
            autoHighlight
            filterOptions={(x) => x}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tên tạp chí quốc tế"
                margin="normal"
                variant="outlined"
                InputProps={{ ...params.InputProps }}
              />
            )}
            style={{ marginBottom: -10, marginTop: -16 }}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <TextField
          fullWidth
          size="small"
          disabled={props.disabled}
          label="Tên tạp chí khác (trong trường hợp hệ thống không có tạp chí cần tìm)"
          variant="outlined"
          value={values?.otherTitle || ""}
          onChange={(event) => handleChangeForm("otherTitle", event.target.value)}
        />
      </Grid>
      <Grid item xs={12} style={{ margin: "auto" }}>
        <Divider />{" "}
      </Grid>
      <Grid item xs={6}>
        <TextField
          size="small"
          disabled={props.disabled}
          label="Xếp loại Q"
          variant="outlined"
          value={values?.sjrBestQuartile ?? values?.publication?.sjrBestQuartile ?? ""}
          style={{ width: "100%" }}
          onChange={(event) => handleChangeForm("sjrBestQuartile", event.target.value)}
        />
      </Grid>
      {/* <Grid item xs={2}>
        <TextField
          size="small"
          disabled={props.disabled}
          label="Xếp loại R"
          variant="outlined"
          value={values?.rank ?? values?.publication?.rank ?? ""}
          style={{ width: "100%" }}
          onChange={(event) => handleChangeForm("rank", event.target.value)}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          size="small"
          disabled={props.disabled}
          label="Top Ngành"
          variant="outlined"
          value={values?.topRank ?? values?.publication?.topRank ?? ""}
          style={{ width: "100%" }}
          onChange={(event) => handleChangeForm("topRank", event.target.value)}
        />
      </Grid> */}
      <Grid item xs={6}>
        <TextField
          size="small"
          disabled={props.disabled}
          label="ISI/Scopus"
          variant="outlined"
          value={values?.coreCollection ?? values?.publication?.coreCollection ?? ""}
          style={{ width: "100%" }}
          onChange={(event) => handleChangeForm("coreCollection", event.target.value)}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          size="small"
          disabled={props.disabled}
          label="Impact factor"
          variant="outlined"
          type="number"
          value={values?.impactFactor ?? values?.publication?.impactFactor ?? ""}
          style={{ width: "100%" }}
          onChange={(event) => handleChangeForm("impactFactor", event.target.value)}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          size="small"
          disabled={props.disabled}
          label="Impact factor 5 years"
          variant="outlined"
          type="number"
          value={values?.impactFactorFiveYear ?? values?.publication?.impactFactorFiveYear ?? ""}
          style={{ width: "100%" }}
          onChange={(event) => handleChangeForm("impactFactorFiveYear", event.target.value)}
        />
      </Grid>
      <Grid item xs={4}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => handleGetRankFromJournal()}
          disabled={
            props.disabled ||
            props.isFetchingJournalDetail ||
            values?.locked === "kpi" ||
            values?.locked === "reward" ||
            values?.lockedForTimeResearch
          }
        >
          {props.isFetchingJournalDetail && <CircularProgress size={24} />}
          {!props.isFetchingJournalDetail && "Tính xếp hạng"}
        </Button>
      </Grid>
      <Grid item xs={12} style={{ margin: "auto" }}>
        <Divider />{" "}
      </Grid>
    </>
  );
}

const mapStateToProps = (state) => ({
  DOI: select(state, "scientificResearchReducer", "DOI"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  listSearch: select(state, "journalReducer", "listSearch"),
  journalDetail: select(state, "journalReducer", "detailOnScientificResearch"),
  infoFromDoiLink: select(state, "journalReducer", "infoFromDoiLink"),
  listSearchAfterDOI: select(state, "journalReducer", "listSearchAfterDOI"),
  journalSearchFilterText: select(state, "journalReducer", "searchFilterText"),

  isNeedReload: select(state, "scientificResearchReducer", "isNeedReload"),
  isFetchingDOI: select(state, "scientificResearchReducer", "isFetchingDOI"),
  isFetchingJournal: select(state, "journalReducer", "isFetching"),
  isFetchingAfterDOI: select(state, "journalReducer", "isFetchingAfterDOI"),
  isFetchingJournalDetail: select(state, "journalReducer", "isFetchingDetailOnScientificResearch"),
  isFetchingJournalSearchFilter: select(state, "journalReducer", "isFetchingSearchFilter"),
});

const mapDispatchToProps = (dispatch) => ({
  getDOI: (url) => dispatch(getDOI(url)),
  notification: (payload) => dispatch(notification(payload)),
  getJournalByIdOnScientificResearch: (id) => dispatch(getJournalByIdOnScientificResearch(id)),
  getSearchFilteredJournal: (page, pageSize, payload) => dispatch(getSearchFilteredJournal(page, pageSize, payload)),
  getSearchFilteredJournalAfterDOI: (page, pageSize, payload, doiInfo) =>
    dispatch(getSearchFilteredJournalAfterDOI(page, pageSize, payload, doiInfo)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(JournalInternational));

